import { Create, SimpleForm } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import SaveForm from "./SaveForm";

const CreateCurriculumSelectionCampaign = () => {
  return (
    <Create
      title="Създаване на кампания за избор на учебен план"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm>
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};

export default CreateCurriculumSelectionCampaign;
